<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="1" :tab="$t('tab.unLocked')" style="margin-top: -14px">
        <InventoryUnLockedTable ref="unlockedTable" :inventoryStateData="inventoryStateData" @success="lockSuccess"></InventoryUnLockedTable>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('tab.locked')" forceRender style="margin-top: -14px">
        <InventoryLockedTable ref="lockedTable" :inventoryStateData="inventoryStateData" @success="unlockSuccess"></InventoryLockedTable>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <vxe-button :disabled="locking" content="button.lockingStock" size="mini" status="primary" @click="lock"/>
        <vxe-button :disabled="!locking" content="button.unLockingStock" size="mini" status="primary" @click="unlock"/>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      </a-space>
    </a-tabs>
  </a-layout>
</template>
<script>
import { findEnum } from '@/api/Api'
import InventoryUnLockedTable from '@/views/operation/inventory_lock/InventoryUnLockedTable.vue'
import InventoryLockedTable from '@/views/operation/inventory_lock/InventoryLockedTable.vue'

export default {
    name: 'InventoryLock',
    components: {InventoryUnLockedTable, InventoryLockedTable},
    data() {
      return {
        activeKey: '1',
        locking: false,
        reason: '',
        quantity: null,
        inventoryStateData: []
      }
    },
    watch: {
      activeKey(key) {
        switch (key) {
          case '1':
            this.locking = false
            this.$refs.unlockedTable.getData()
            break
          case '2':
            this.locking = true
            this.$refs.lockedTable.getData()
            break
        }
      }
    },
    mounted() {
      findEnum('InventoryState').then(res => {
        this.inventoryStateData = res.result
      })
    },
    methods: {
      refresh() {
        if (this.activeKey === '1') {
          this.$refs.unlockedTable.getData()
        } else {
          this.$refs.lockedTable.getData()
        }
      },
      lock() {
        this.$refs.unlockedTable.lock()
      },
      unlock() {
        this.$refs.lockedTable.unLocking()
      },
      reset() {
        if (this.activeKey === '1') {
          this.$refs.unlockedTable.reset()
        } else {
          this.$refs.lockedTable.reset()
        }
      },
      lockSuccess() {
        this.$refs.lockedTable.getData()
      },
      unlockSuccess() {
        this.$refs.unlockedTable.getData()
      }
    }
  }
</script>
<style scoped>
</style>